// @flow

import type {Account, Merchant} from 'docs/data';

export type GetLoginUrlOptions = {|
  account: Account,
  merchant?: Merchant,
  returnUrl?: string,
  isSiteAdmin?: boolean,
|};

export const getLoginUrl = ({
  account,
  merchant,
  returnUrl,
  isSiteAdmin,
}: GetLoginUrlOptions) => {
  const redirect = returnUrl ? encodeURIComponent(returnUrl) : null;
  let url;
  if (isSiteAdmin) {
    // This is a hack to login to docs on site-admin. Due to security changes we can no longer use
    // manage to log into docs on site-admin.
    url = `https://admin.corp.stripe.com/gallery/merchant-context?path=/merchants/:merchant/login_as`;
  } else if (merchant) {
    url = `${account.dashboardUrl}/b/${merchant.token}?force_merchant_login=true`;
    if (redirect) {
      url += `&destination=${redirect}`;
    }
  } else {
    url = `${account.dashboardUrl}/login`;
    if (redirect) {
      url += `?redirect=${redirect}`;
    }
  }

  return url;
};
